import React from "react";
import { useSeo } from "../useSeo";
import { trackEvent } from "../trackEvent";
import { MINISTRIES } from "../data";
import { useNavigate } from "react-router-dom";

const ICONS = {
  brandOrange1: <><rect x="6" y="3" width="12" height="18" rx="1" /><path d="M9 3v18" /><circle cx="13.5" cy="12" r="1" fill="currentColor" stroke="none" /></>,
  brand: <><path d="M9 18V5l10-2v13" /><circle cx="6" cy="18" r="3" /><circle cx="16" cy="16" r="3" /></>,
  brandBlue: <><path d="M8 8V6a4 4 0 0 1 8 0v2" /><rect x="5" y="8" width="14" height="12" rx="2.5" /><path d="M9 8v3.5M15 8v3.5" /><rect x="9.5" y="13" width="5" height="3.5" rx="1" /></>,
  brandPurple: <><circle cx="9" cy="8" r="3" /><path d="M3 20c.6-3.6 3-5.6 6-5.6s5.4 2 6 5.6" /><circle cx="17" cy="9" r="2.4" /><path d="M15.5 14.7c2.3.4 3.9 2.1 4.5 5.3" /></>,
  brandGreen: <path d="M12 21s-7-4.5-9.5-9A5.5 5.5 0 0 1 12 6.5 5.5 5.5 0 0 1 21.5 12c-2.5 4.5-9.5 9-9.5 9Z" />,
  brandOrange2: <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v7A2.5 2.5 0 0 1 17.5 15H9l-5 4v-4.5A2.5 2.5 0 0 1 4 12.5Z" />,
  // "Mãos + coração" (ícone "heart-handshake" da lucide-react, já usada em
  // outras telas do app -- ver AdminHome.jsx) pro Reino do Bem, o braço
  // social da igreja: precisa de um ícone diferente do coração sozinho
  // (ICONS.brandGreen, ja usado pela Diaconia & Cuidado) pra não confundir
  // as duas áreas de cuidado, uma interna (membros) e outra externa
  // (comunidade ao redor).
  brandRed: <path d="M19.414 14.414C21 12.828 22 11.5 22 9.5a5.5 5.5 0 0 0-9.591-3.676.6.6 0 0 1-.818.001A5.5 5.5 0 0 0 2 9.5c0 2.3 1.5 4 3 5.5l5.535 5.362a2 2 0 0 0 2.879.052 2.12 2.12 0 0 0-.004-3 2.124 2.124 0 1 0 3-3 2.124 2.124 0 0 0 3.004 0 2 2 0 0 0 0-2.828l-1.881-1.882a2.41 2.41 0 0 0-3.409 0l-1.71 1.71a2 2 0 0 1-2.828 0 2 2 0 0 1 0-2.828l2.823-2.762" />
};
const ICON_BY_INDEX = [ICONS.brandOrange1, ICONS.brand, ICONS.brandBlue, ICONS.brandPurple, ICONS.brandGreen, ICONS.brandOrange2, ICONS.brandRed];
const COLOR_MAP = { brand: "var(--brand)", brandBlue: "var(--blue)", brandPurple: "var(--purple)", brandGreen: "var(--green)", brandOrange: "var(--orange)", brandRed: "var(--red)" };

export default function Ministerios() {
  useSeo({
    title: "Ministérios | Igreja Batista Mosaico",
    description: "Conheça os ministérios e pequenos grupos da Igreja Batista Mosaico em Osasco: acolhida, louvor, Kids & Teens, pequenos grupos, diaconia, comunicação e o braço social Reino do Bem.",
    path: "/ministerios"
  });
  const navigate = useNavigate();

  function goServe(ministryName) {
    trackEvent("ministry_connect_click", { ministry: ministryName });
    navigate("/contato", { state: { prefillMessage: `Oi! Quero saber mais sobre como servir em ${ministryName}.` } });
  }

  return (
    <>
      <div className="section-head" style={{ marginTop: 34 }}>
        <p className="eyebrow">Ministérios &amp; pequenos grupos</p>
        <h1>Onde você pode servir e pertencer</h1>
        <p>Nenhuma área aqui existe pra encher agenda — cada uma é um jeito concreto de cuidar de alguém ou de ser cuidado.</p>
      </div>
      <div className="grid grid-3">
        {MINISTRIES.map((m, i) => (
          <div className="card min-card" key={m.name}>
            <div className="icon" style={{ background: COLOR_MAP[m.color] }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{ICON_BY_INDEX[i]}</svg>
            </div>
            <h3>{m.name}</h3>
            <p>{m.desc}</p>
            <button className="serve-link" onClick={() => goServe(m.name.replace(/&/g, "e"))}>Quero servir aqui →</button>
          </div>
        ))}
      </div>
    </>
  );
}
